import { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isNullOrEmpty, showMessageToastCustom, translate } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Input, Button, Table, Card } from '../../../../components/UI/ComponentsUI'
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';

const SpawningPhysicalConfirmation = (props) => {
    const [container, setContainer] = useState({});
    const [filter, setFilter] = useState({
        name: "",
    });

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const searchContainer = () => {
        if (validateInputsRequired('getChange')) {
            props.getContainerMvm(filter, (response) => {
                if (response) {
                    if (isNullOrEmpty(response.mvmNumber)) {
                        return showMessageToastCustom(translate('warning', 'general'), "MVM não encontrado", 3000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    setContainer(response);
                } else {
                    setContainer({})
                    showMessageToastCustom(translate('warning', 'general'), "Container não encontrado", 3000, 'mdi mdi-alert-circle-outline red-text');
                }
            })
        }
    }

    const redirect = (data) => {
        props.history.replace({
            pathname: '/receipt/V2/receiptParameters',
            state: {
                filterContainer: data.name,
                filtermvmNumber: data.mvmNumber,
                filterJourney: data.journey
            },
            ...props
        });
    }

    return (
        <div>
            <Card>
                <div id="getChange" className="col s12">
                    <div className="row" style={{ padding: '10px' }}>
                        <div className="input-field no-padding col s6">
                            <Input
                                id="name"
                                name='name'
                                maxLength="11"
                                label="Num. Container"
                                required
                                type="text"
                                value={filter?.name || ''}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="row" style={{ paddingTop: '5px' }}>
                    <Button full="true"
                        text="Buscar"
                        onClick={searchContainer} />
                </div>
                <Table
                    totalPages={0}
                    onClickRow={(row) => redirect(row)}
                    disablePaged={true}
                    col={[
                        {
                            field: 'name',
                            header: 'Container',
                            align: 'left',
                        },
                        {
                            field: 'mvmNumber',
                            header: 'Nº Mvm',
                            align: 'left',
                        },
                        {
                            field: 'journey',
                            header: 'Viagem',
                            align: 'left',
                        },
                        {
                            field: 'statusDescription',
                            header: 'Status',
                            align: 'left',
                        }
                    ]}
                    data={[container]}
                />
            </Card>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        containers: state.containerReducer.containers,
        containerStatus: state.containerReducer.containerStatus,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getContainerMvm: (filter, callback) => {
            dispatch(ContainerService.getContainerMvm(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SpawningPhysicalConfirmation));
